// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pCWLn","footer":"styles_footer__3bKpf"};